import { AppState, EDITOR_MODE } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppEditorModeReducer = (state: AppState, action: PayloadAction<EDITOR_MODE>) => {
  state.editorMode = action.payload;
};

export default setAppEditorModeReducer;
